import { FormikContextType } from 'formik';

import { ICalculationClassUI, OOControlModelInterface } from '../interfaces';

export class MonthsToExcludeCalculator implements ICalculationClassUI {
  control: OOControlModelInterface;
  relevantControls: OOControlModelInterface[];
  allControls: OOControlModelInterface[];
  formik: FormikContextType<Record<string, any>>;

  constructor(
    control: OOControlModelInterface,
    formControls: OOControlModelInterface[] | undefined,
    formik: FormikContextType<Record<string, any>>,
  ) {
    this.control = control;
    this.relevantControls = [];
    this.allControls = formControls ?? [];
    this.formik = formik;
  }

  async init(value?: any) {
    const originalName = this.control.originalName;
    const excludedSelectItems: string[] = [];
    Object.keys(this.formik.values).forEach((key: string) => {
      if (key.split(':').pop() === originalName) {
        if (this.formik.values[key] && value !== this.formik.values[key]) {
          excludedSelectItems.push(this.formik.values[key]);
        }
      }
    });
    this.control.excludedSelectItems = { excludeList: excludedSelectItems, exludeColumn: 'value' };
    return;
  }

  onChange = (event: any) => {
    return;
  };
}
